export default __webpack_public_path__ + "static/media/location_mark.a8890120.svg";